import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { TAction } from '../../../types/customActions';

type TUserCardDesktopCustomActionButtonProps = {
  action: TAction;
  longText: string;
  onClick(action: TAction): void;
};

export const UserCardDesktopCustomActionButton: React.VFC<TUserCardDesktopCustomActionButtonProps> = ({
  action,
  longText,
  onClick,
}) => {
  return (
    <button className={styles['text']} onClick={() => onClick(action)} data-testid="UserCardDesktopCustomActionButton">
      <UIText1>{longText}</UIText1>
    </button>
  );
};
